import { createSlice } from "@reduxjs/toolkit";
import { categoryService } from "./services/categoryServise";
import { RootState } from "./store";

interface CategoryState {
  categories: any; 
  loading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  categories: [],
  loading: false,
  error: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    getCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCategorySuccess(state, action) {
      state.categories = action.payload;
      state.loading = false;
    },
    getCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      categoryService.endpoints.getCategoryListByRestaurantId.matchFulfilled,
      (state, { payload }) => {
        state.categories = payload.categories;
        state.loading = false;
        state.error = null;
      }
    );
    
  },
});

export const { getCategoryStart, getCategorySuccess, getCategoryFailure } =
  categorySlice.actions;

export const selectCategories = (state: RootState) => state.category;
export const selectCategoryLoading = (state: RootState) =>
  state.category;
export const selectCategoryError = (state: RootState) => state.category;

export default categorySlice.reducer;
